/**
 * Задаёт высоту textarea в блоке комментариев при вводе текста
 *
 * @export
 * @param {*} form
 */
export default function (form) {
	const textarea = form.querySelector('textarea');
	const btnSubmit = form.querySelector('.comments__form-btn');

	textarea.addEventListener('keyup', function () {
		const isTextareaEmpty = textarea.value.length === 0;

		textarea.style.height = `${textarea.scrollHeight}px`;
		btnSubmit.classList.toggle('comments__form-btn_active', !isTextareaEmpty);
	});
}
